import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface UsersPageLayoutProps {
  sidebar: ReactNode;
  topBar: ReactNode;
  content: ReactNode;
}

const UsersPageLayout = ({ sidebar, topBar, content }: UsersPageLayoutProps) => {
  return (
    <div className="flex flex-col h-full">
      {/* Top Bar */}
      {topBar}

      <div className="flex flex-1 overflow-hidden">
        {/* Sidebar */}
        <aside className={cn(
          'w-64 bg-background border-r border-border shrink-0',
          'md:block hidden' // Hide on mobile, show on md+
        )}>
          {sidebar}
        </aside>

        {/* Main Content */}
        <main className="flex-1 overflow-auto p-4">
          {content}
        </main>
      </div>
    </div>
  );
};

export default UsersPageLayout;
